
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { Message } from 'src/app/model/message.model';
import { MessageService } from 'src/app/services/message.service';
import { PaginationInfo } from 'src/app/utils/pagination-info.model';

@Component({
  selector: 'app-user-messages',
  templateUrl: './user-messages.component.html',
  styleUrls: ['./user-messages.component.scss']
})
export class UserMessagesComponent implements OnInit {

  paginationInfo: PaginationInfo;
  messages: Observable<Message[]>;
  querySub: Subscription;

  constructor(private messageService: MessageService,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.messages = this.messageService.messages;
    this.messageService.paginationInfo.subscribe(pi => this.paginationInfo = pi);
  }
}
